module.exports = __webpack_public_path__ + "static/media/feed-wireframe.b394452c.png";